var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopBgShadowBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 370,
    viewBox: "0 0 554 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1753 369.969L705 369.969C713.284 369.969 720 363.253 720 354.969L720 39.9043C648.106 14.5935 563.516 -1.36803e-05 472.985 -2.15948e-05C211.763 -4.44315e-05 0.000111448 121.503 9.83451e-05 271.385C9.53048e-05 306.162 11.401 339.411 32.1753 369.969Z",
    fill: "#0008C3",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopBgShadowBottom);
export default __webpack_public_path__ + "static/media/desktop-bg-shadow-bottom.fdd08f56f5429bc7b64f01acddbbb0c2.svg";
export { ForwardRef as ReactComponent };